<section [formGroup]="form">
  <div class="lbl">Content <span class="meta-inline">this page's own; the template's blocks read it</span></div>

  <div class="field">
    <label class="sub" for="sp-intro">Opening paragraph <span class="meta-inline">{{ introWords }} words</span></label>
    <textarea id="sp-intro" pInputTextarea formControlName="intro" rows="3" [autoResize]="true" class="w-full page-intro"
              placeholder="One or two sentences about funeral services here, under the page's heading."></textarea>
    <small *ngIf="empty('intro')" class="empty-note">Empty: the website writes a lead from the nearest places instead, when it can.</small>
    <button *ngIf="draftsWaiting" type="button" class="p-button-text p-button-sm px-0" pButton icon="pi pi-inbox"
            [label]="'AI drafts waiting: ' + draftsWaiting" (click)="openDrafts.emit()"></button>
  </div>

  <div class="field">
    <label class="sub">About</label>
    <app-markdown-editor formControlName="body" [heightRem]="7.5" [autoGrow]="true" imageBucketPrefix="page-body" imageAltFallback="Suburb image"
                         placeholder="What's particular about funeral services here. Headings, bold, links and lists work."></app-markdown-editor>
    <small *ngIf="empty('body')" class="empty-note">Empty: its block is hidden.</small>
  </div>

  <div class="field">
    <label class="sub">Hero photo</label>
    <div class="flex align-items-center gap-2 flex-wrap">
      <img *ngIf="heroPreview" [src]="heroPreview" alt="The hero photo" class="hero-preview" />
      <button pButton type="button" class="p-button-outlined p-button-sm" icon="pi pi-upload" [label]="empty('heroFileId') ? 'Upload photo' : 'Replace photo'" (click)="uploadHero.emit()"></button>
      <button *ngIf="!empty('heroFileId')" pButton type="button" class="p-button-text p-button-danger p-button-sm" label="Remove" (click)="removeHero.emit()"></button>
    </div>
    <small *ngIf="empty('heroFileId')" class="empty-note">Empty: the template's photo is used.</small>
  </div>

  <div class="field">
    <label class="sub">FAQs</label>
    <p-multiSelect formControlName="faqIds" [options]="faqOptions" optionLabel="label" optionValue="value" display="chip" styleClass="w-full page-faqs"
                   appendTo="body" [baseZIndex]="12000" [filter]="true" filterPlaceHolder="Search questions" placeholder="Choose this page's FAQs"
                   emptyMessage="No FAQs yet: add them under Website FAQs"></p-multiSelect>
    <small *ngIf="empty('faqIds')" class="empty-note">Empty: its block is hidden.</small>
  </div>
</section>
